import React from "react";
import { Box, Typography, Container, Divider } from "@mui/material";

const PrivacyPolicy = () => {
  const sections = [
    {
      title: "1. Introduction",
      content: `Welcome to JEMINS Builders & Developers Private Limited. This Privacy Policy explains how we collect,
      use, store, and protect your personal information when you use our website
      and services.`,
    },
    {
      title: "2. Information We Collect",
      content: `We collect information provided directly by users and information
      automatically collected during your use of the platform.`,
      points: [
        "Name, phone number, email address",
        "Property details, images, and descriptions",
        "IP address, browser type, device information",
      ],
    },
    {
      title: "3. Use of Information",
      content: `The information collected is used to operate, improve, and secure
      our services.`,
      points: [
        "Publishing and managing property listings",
        "Improving user experience",
        "Fraud prevention and security monitoring",
      ],
    },
    {
      title: "4. Sharing of Information",
      content: `Jemins does not sell or rent your personal data.`,
      points: [
        "Shared with service providers strictly for platform operations",
        "Disclosed when required by law or legal authorities",
        "Transferred during business restructuring or acquisition",
      ],
    },
    {
      title: "5. Cookies & Tracking",
      content: `We use cookies and similar technologies to improve platform
      performance and user experience.`,
      points: [
        "Session and persistent cookies",
        "Analytics and performance tracking",
        "Users may disable cookies via browser settings",
      ],
    },
    {
      title: "6. Data Security",
      content: `We implement reasonable technical and organizational measures to
      protect user data. However, no system is completely secure.`,
    },
    {
      title: "7. Data Retention",
      content: `Personal data is retained only for as long as necessary to fulfill
      the purposes outlined in this policy or as required by law.`,
    },
    {
      title: "8. User Rights",
      content: `You may request access, correction, or deletion of your personal
      information, subject to applicable laws.`,
    },
    {
      title: "9. Third-Party Links",
      content: `Our website may contain links to third-party websites. Jemins is not
      responsible for their privacy practices.`,
    },
    {
      title: "10. Changes to this Policy",
      content: `This Privacy Policy may be updated periodically. Continued use of
      the platform constitutes acceptance of the revised policy.`,
    },
    {
      title: "11. Contact Information",
      content: `For questions or concerns regarding this Privacy Policy, contact us
      at jemins_realmart@jemins.in`,
    },
  ];

  return (
    <Box sx={{ backgroundColor: "#fff", py: 6 }}>
      <Container maxWidth="md">
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, mb: 1 }}
        >
          Privacy Policy
        </Typography>

        <Typography sx={{ color: "text.secondary", mb: 4 }}>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Divider sx={{ mb: 4 }} />

        {sections.map((section, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, mb: 1.5 }}
            >
              {section.title}
            </Typography>

            <Typography sx={{ color: "text.secondary", mb: 1.5 }}>
              {section.content}
            </Typography>

            {section.points && (
              <Box component="ul" sx={{ pl: 3, color: "text.secondary" }}>
                {section.points.map((point, i) => (
                  <li key={i}>
                    <Typography sx={{ mb: 0.5 }}>
                      {point}
                    </Typography>
                  </li>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;